import React, { useState } from 'react';
import parts from '../moduleCard/moduleParts.module.css';
import CustomButton from "../../../../components/buttons/CustomButton";
import IconAdd from '@mui/icons-material/Add';
import MainPainItem from './MainPainItem';
import ModuleCard from '../moduleCard/ModuleCard';
import ComplaintsPopupContent from '../../../../popup/ComplaintsPopupContent/ComplaintsPopupContent';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import ModulePdfButton from '../moduleCard/ModulePdfButton';
import HiddenReport from '../../../../components/documents-templates/report/HiddenReport';
import useReportExport from '../../../../components/documents-templates/report/useReportExport';
import ModuleReportTemplate from '../../../../components/documents-templates/report/ModuleReportTemplate';
import { MODULE_KEYS } from '../../modules/appointmentModules';
import { REPORT_SECTIONS, buildComplaintsJob } from '../../modules/reportSections';

const SECTION = REPORT_SECTIONS[MODULE_KEYS.COMPLAINTS];

/**
 * `patientName`, `professionalId`, `companyConfig`: identificação no PDF das
 * queixas (mesmo miolo da seção do relatório completo).
 */
const MainPain = ({ onChange, list, history, enabled, patientName, professionalId, companyConfig }) => {

  const [pains, setPains] = useState(list || []);
  const [popupVisible, setPopupVisible] = useState(false);

  function OnAddHandler() {
    setPopupVisible(true);
  }

  function OnComplaintAddItemsHandler(values) {
    if (!values || !Array.isArray(values)) return;
    let newValues = values.map((item) => item?.label || '').filter(label => label);
    SaveValues([...(pains || []), ...newValues]);
  }

  function OnRemoveItemHandler(item) {
    if (!enabled) return;
    let newItems = (pains || []).filter((i) => i != item);
    SaveValues(newItems);
  }

  function SaveValues(values) {
    const safeValues = values || [];
    setPains(safeValues);
    if (onChange) {
      onChange(safeValues);
    }
  }

  function cleanHtmlTags(text) {
    // Primeiro remove as tags HTML, depois substitui a string literal "\n" por quebras de linha reais
    const withoutHtml = text.replace(/<[^>]*>?/gm, '');
    // Substitui a sequência literal de caracteres "\n" por quebras de linha reais
    return withoutHtml.replace(/\\n/g, '\n');
  }

  const assessment = history && Array.isArray(history) && history.length > 0 && history[history.length - 1]?.assessment
    ? cleanHtmlTags(history[history.length - 1].assessment)
    : '';

  const hasPains = pains && Array.isArray(pains) && pains.length > 0;

  const report = useReportExport({
    patientName,
    professionalId,
    companyConfig,
    reportType: SECTION.reportType,
    prepare: () => buildComplaintsJob(pains, history),
  });

  return (
    <>
      {popupVisible && <ComplaintsPopupContent InitialData={pains} OnSave={OnComplaintAddItemsHandler} OnHide={() => setPopupVisible(false)} />}

      <ModuleCard
        accent="pink"
        title="Queixas Principais"
        icon={<MedicalInformationOutlinedIcon />}
        description="Lista de queixas para acompanhar ao longo do tratamento"
        actions={(
          <>
            {(hasPains || assessment) && <ModulePdfButton report={report} />}
            {enabled && (
              <CustomButton
                variant="outlined"
                style="primary"
                label="Adicionar"
                icon={<IconAdd />}
                onClick={OnAddHandler}
              />
            )}
          </>
        )}
      >
        {hasPains && (
          <div className={parts.chips}>
            {pains.map((item, index) => (
              <MainPainItem key={index} label={item || ''} enabled={enabled} OnRemove={OnRemoveItemHandler} />
            ))}
          </div>
        )}

        {/* Vazio só quando não há nada na tela: a primeira avaliação também é queixa */}
        {!hasPains && !assessment && (
          <span className={parts.muted}>Nenhuma queixa registrada.</span>
        )}

        {assessment && (
          <div className={parts.item}>
            <span className={parts.sectionLabel}>Primeira avaliação</span>
            <span className={parts.itemText}>{assessment}</span>
          </div>
        )}
      </ModuleCard>

      {report.job && (
        <HiddenReport>
          <ModuleReportTemplate ref={report.ref} section={SECTION} job={report.job} {...report.paperProps} />
        </HiddenReport>
      )}
    </>
  );
};

export default MainPain;
